import React, { useEffect, useState } from 'react'
import productServices from '../../services/ProductsServices'
import { BiSolidAddToQueue } from "react-icons/bi";
import { useSession } from '../../context/SessionContext';
import Empty from '../feedback/Empty';
import moment from 'moment';
import ProductModelModal from './ProductModelModal';

function ModelsList() {
    const [models, setModels] = useState()
    const [action, setAction] = useState(0)
    const [activeModel, setActiveModel] = useState()
    const  {brands} = useSession()

    useEffect(() => {
        getModels()
    }, [])

    const getModels = () => {
        productServices.getModels().then(
            res => {
                setModels(res.data)
            },
            err => {
                console.log(err);

            }
        )
    }

    function openModal(action, model) {
        const openBtn = document.getElementById("product-model-open-btn")
        if (action === 0) {
            setAction(0)
        }
        if (action === 1) {
            setAction(1)
            setActiveModel(model)
        }
        openBtn.click()
    }
    return (
        <details className="collapse collapse-arrow bg-white dark:bg-slate-800 rounded-lg shadow-sm overflow-hidden border border-border-light dark:border-border-dark">
            <summary className="collapse-title font-semibold">Model List <span className='ml-3 text-gray-600'>{"("}{models?.length || 0}{")"}</span></summary>
            <div className="collapse-content border-t pt-3">
                <div className=''>
                    <ProductModelModal
                        brands={brands}
                        action={action}
                        activeModel={activeModel}
                        getModels={getModels}
                    />
                    <div className='mb-3'>
                        <div className="flex justify-end items-center">
                            <button
                                onClick={() => openModal(0)}
                                className='btn btn-primary btn-sm'><BiSolidAddToQueue className='h-4 w-4 mr-2' /> Add Model</button>
                        </div>
                        {models?.length ? (
                            <div className='overflow-x-auto mt-3'>
                                <table className="table table-compact table-zebra w-full">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th className='hidden md:table-cell'>Brand</th>
                                            <th>Product Count</th>
                                            <th className='hidden md:table-cell'>Created</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {models?.map((model, idx) => (
                                            <tr
                                                key={idx}>
                                                <td className='font-bold'>
                                                    {model?.name}
                                                </td>
                                                <td className='hidden md:table-cell'>
                                                    {model?.brand?.name || '-'}
                                                </td>
                                                <td>
                                                    {model?.product_count}
                                                </td>
                                                <td className='hidden md:table-cell'>
                                                    {moment(model?.creation_time).format("MMM Do YYYY")}
                                                </td>
                                                <td>
                                                    <button
                                                        onClick={() => openModal(1, model)}
                                                        className='btn btn-sm btn-primary'>View</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <Empty objectName={"models"} />
                        )}
                    </div>
                </div>
            </div>
        </details>
    )
}

export default ModelsList